module.exports = __webpack_public_path__ + "img/specifications.7f0c4fd9.png";